import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=16aebd75&scoped=true"
import script from "./terms.vue?vue&type=script&lang=ts"
export * from "./terms.vue?vue&type=script&lang=ts"
import style0 from "./terms.vue?vue&type=style&index=0&id=16aebd75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aebd75",
  null
  
)

export default component.exports